<!--
 * @Author: baiwei
 * @Date: 2020-05-18 14:26:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-02 16:50:37
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <div class="trans-pack">
        <div>
            <div class="header">
                {{$t('未选择')}}
                <Checkbox :value="checkVal"
                          @on-change="checkAll">{{$t('全选')}}</Checkbox>
            </div>
            <div class="list-pack">
                <div class="search-pack">
                    <Input v-model="leftSearchVal"
                           size="small"
                           suffix="ios-search"
                           clearable
                           :placeholder="$t('名称')" />
                </div>
                <ul>
                    <li v-for="item in unselected"
                        :key="item.key"
                        @click="rightShift(item.key)">
                        <span :title="item.name">{{$t(item.name)}}</span>
                        <p :title="item.description">{{$t(item.description)}}</p>
                    </li>
                    <li v-show="!unselected.length"
                        class="no-data">{{$t('暂无数据')}}</li>
                </ul>
            </div>
        </div>
        <div>
            <div class="header">
                {{$t('已选择')}}
                <a @click="clear">{{$t('清空')}}</a>
            </div>
            <div class="list-pack">
                <div class="search-pack">
                    <Input v-model="rightSearchVal"
                           size="small"
                           suffix="ios-search"
                           clearable
                           :placeholder="$t('名称')" />
                </div>
                <ul class="right">
                    <li v-for="item in selected"
                        :key="item.key"
                        :title="item.title||''">
                        <span :title="item.name">{{$t(item.name)}}</span>
                        <p :title="item.description">{{$t(item.description)}}</p>
                        <!--配置用户-->
                        <i class="icon-delete-1"
                           v-show="disabledData!=undefined"
                           v-if="(!(disabledData!=undefined&&(disabledData.indexOf(item.key)!=-1||!hasPermission('CH0113'))))&&((String(userSid) === String(item.key)&&!disOneself&&!item.disabled)||(!item.disabled&&String(userSid) !== String(item.key)))"
                           @click="leftShift(item.key)"></i>
                        <!--配置权限-->
                        <i class="icon-delete-1"
                           v-show="groupDisabledData!=undefined"
                           v-if="(!(groupDisabledData!=undefined&&(groupDisabledData.indexOf(item.key)!=-1||!hasPermission('CH0207'))))&&((String(userSid) === String(item.key)&&!disOneself&&!item.disabled)||(!item.disabled&&String(userSid) !== String(item.key)))"
                           @click="leftShift(item.key)"></i>
                        <!--其他-->
                        <i class="icon-delete-1"
                           v-show="disabledData==undefined&&groupDisabledData==undefined"
                           v-if="((String(userSid) === String(item.key)&&!disOneself&&!item.disabled)||(!item.disabled&&String(userSid) !== String(item.key)))"
                           @click="leftShift(item.key)"></i>
                    </li>
                    <li v-show="!selected.length"
                        class="no-data">{{$t('暂无数据')}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'customtransfer',
    components: {
    },
    props: ['data', 'targetKeys', 'initialSelected', 'disOneself', 'disabledData', 'groupDisabledData'],
    data () {
        return {
            // checkVal: false,
            leftSearchVal: '',
            rightSearchVal: '',
            userSid: this.$store.state.user.currentUser.info.userSid // 如果当前用户组中，不允许移除
            // selectedKeys: []
        }
    },
    created () { },
    computed: {
        checkVal () {
            return this.data.length === this.targetKeys.length
        },
        unselected () {
            return this.data.filter(item => !this.targetKeys.includes(item.key) && this.search(item, this.leftSearchVal))
        },
        selected () {
            return this.data.filter(item => this.targetKeys.includes(item.key) && this.search(item, this.rightSearchVal))
        }
    },
    methods: {
        search (data, query) {
            return !query || `${data.name} ${data.description || ''}`.includes(query)
        },
        rightShift (val) {
            this.$emit('on-change', this.targetKeys.concat(val))
        },
        leftShift (val) {
            this.$emit('on-change', this.targetKeys.filter(key => key !== val))
        },
        checkAll () {
            this.$emit('on-change', this.data.map(item => item.key))
        },
        clear () {
            if (this.initialSelected) {
                this.$emit('on-change', this.targetKeys.filter(key => this.initialSelected.includes(key)))
            } else {
                this.$emit('on-change', this.data.filter(item => item.disabled).map(item => item.key))
            }
        }
    }
}
</script>
<style lang="less" scoped>
.trans-pack {
    display: flex;
    & > div {
        width: 50%;
        border: 1px solid #e8eaec;
        &:first-child {
            margin-right: 10px;
        }
    }
    .header {
        padding: 8px 16px;
        line-height: 1.5;
        background-color: #f9fafc;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e8eaec;
    }
    .list-pack {
        .search-pack {
            padding: 8px 8px 0;
        }
        ul {
            line-height: 1.5;
            height: 140px;
            padding: 4px 0;
            overflow: auto;
            li {
                padding: 5px 12px;
                cursor: pointer;
                span {
                }
                p {
                    color: #999;
                    font-size: 10px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                &:hover {
                    background-color: #f3f3f3;
                }
            }
            .no-data {
                text-align: center;
                color: #999;
            }
            &.right {
                li {
                    position: relative;
                    padding-right: 30px;
                    cursor: auto;
                    i {
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        padding: 5px;
                        font-size: 10px;
                        transform: translate(0, -50%);
                        cursor: pointer;
                        display: none;
                    }
                }
                li:hover i {
                    display: block;
                }
            }
        }
    }
}
</style>
<style lang="less">
.trans-pack {
    .ivu-input-wrapper-small {
        .ivu-input-suffix i {
            line-height: 24px;
        }
    }
}
</style>
